export const sbConfig = {
    serviceInstance: new Object()
}


// WEBPACK FOOTER //
// ./src/app/typescripts/pro/accordion/components/sb.config.ts